import { Controller } from '@hotwired/stimulus'
import { visit } from '@hotwired/turbo'
import { browserTimeZone } from '@/lib/browser-time-zone'
import { initTimeZoneInference } from '@/lib/time-zone-inference'
import type { SharedTimeZone } from '@/types/serializers'

let inferred = false

export default class extends Controller {
  static override values = { source: String, url: String }

  declare readonly sourceValue: SharedTimeZone['source']
  declare readonly urlValue: string

  override connect() {
    if (inferred) return

    inferred = true
    initTimeZoneInference(
      { source: this.sourceValue },
      {
        url: this.urlValue,
        detect: browserTimeZone,
        reload: () => visit(window.location.href, { action: 'replace' }),
        onceRouterReady: (callback) => callback(),
      },
    )
  }
}
